export default __webpack_public_path__ + "static/media/social.d836fdd1.svg";